import {DropdownOption} from "../../../models/dropdown-option.model";

export const rolesLabelMap = {
  1: 'Stanford Admin',
  2: 'Organization Admin',
  3: 'Coach',
  4: 'Adult',
  5: 'Participant'
}


export const roles = {
  valid: [1, 2, 3, 4, 5],
  superAdmin: 1,
  clientAdmin: 2,
  coach: 3,
  adult: 4,
  participant: 5
}

export const roleOptionsConfiguration = {
  1: [
    {
      key: roles['superAdmin'],
      value: 'Stanford Admin'
    },
    {
      key: roles['clientAdmin'],
      value: 'Organization Admin'
    },
    {
      key: roles['coach'],
      value: 'Coach'
    },
    {
      key: roles['adult'],
      value: 'Participant / Adult'
    },

  ],
  2: [
    {
      key: roles['clientAdmin'],
      value: 'Organization Admin'
    },
    {
      key: roles['coach'],
      value: 'Coach'
    },
    {
      key: roles['adult'],
      value: 'Participant / Adult'
    },
  ],
  3: [
    {
      key: roles['coach'],
      value: 'Coach'
    },
    {
      key: roles['adult'],
      value: 'Participant / Adult'
    },
  ],
}

export const genderLabelMap = {
  0: 'Female',
  1: 'Male',
  2: 'Other'
}


export const roleUrlMap = {
  1: 'stanford-admin',
  2: 'organization-admin',
  3: 'coach',
  4: 'adult',
  5: 'participant'
}

export const dropDownOption = {
  'preferNotToAnswer': -1,
  'others': 0,
}


export const step = {
  'step-warning': -1,
  'step-1': 1,
  'step-2': 2,
  'step-3': 3,
  'step-4': 4,
  'step-5': 5,
  'step-6': 6,
}

export const statesList: DropdownOption[] = [
  {key: "AL", value: "AL"},
  {key: "AK", value: "AK"},
  {key: "AZ", value: "AZ"},
  {key: "AR", value: "AR"},
  {key: "CA", value: "CA"},
  {key: "CO", value: "CO"},
  {key: "CT", value: "CT"},
  {key: "DE", value: "DE"},
  {key: "FL", value: "FL"},
  {key: "GA", value: "GA"},
  {key: "HI", value: "HI"},
  {key: "ID", value: "ID"},
  {key: "IL", value: "IL"},
  {key: "IN", value: "IN"},
  {key: "IA", value: "IA"},
  {key: "KS", value: "KS"},
  {key: "KY", value: "KY"},
  {key: "LA", value: "LA"},
  {key: "ME", value: "ME"},
  {key: "MD", value: "MD"},
  {key: "MA", value: "MA"},
  {key: "MI", value: "MI"},
  {key: "MN", value: "MN"},
  {key: "MS", value: "MS"},
  {key: "MO", value: "MO"},
  {key: "MT", value: "MT"},
  {key: "NE", value: "NE"},
  {key: "NV", value: "NV"},
  {key: "NH", value: "NH"},
  {key: "NJ", value: "NJ"},
  {key: "NM", value: "NM"},
  {key: "NY", value: "NY"},
  {key: "NC", value: "NC"},
  {key: "ND", value: "ND"},
  {key: "OH", value: "OH"},
  {key: "OK", value: "OK"},
  {key: "OR", value: "OR"},
  {key: "PA", value: "PA"},
  {key: "RI", value: "RI"},
  {key: "SC", value: "SC"},
  {key: "SD", value: "SD"},
  {key: "TN", value: "TN"},
  {key: "TX", value: "TX"},
  {key: "UT", value: "UT"},
  {key: "VT", value: "VT"},
  {key: "VA", value: "VA"},
  {key: "WA", value: "WA"},
  {key: "WV", value: "WV"},
  {key: "WI", value: "WI"},
  {key: "WY", value: "WY"}
];


export const statusLabelMap = {
  1: 'In Progress',
  2: 'Active',
  3: 'Access Disable'
}

export const dashboardNameSuffixLabelMap = {
  1: 'Organization',
  2: 'Groups',
  3: 'Participant/Caregiver',
  4: 'Participant Weight',
  5: 'Participant Behavior'
}

export const isLar = {
  /**
   * Selected as LAR by the inviter:  -1
   * Not an LAR: 0
   * User attests their own status as LAR: 1
   * User rejects their own status as LAR: null
   */
  selectedAsLarByInviter: -1,
  notLar: 0,
  userAttestedLar: 1,
  userRejectedLar: 2
}

export class clinicStatusLabelMap {
}

export const measurements = {
  metricOption: {
    valid: ['height', 'weight', 'bp'],
    height: 'height',
    weight: 'weight',
    bp: 'bp',
  }
}

export const indicatorColors = {
  blue: '#0070E0',
  green: '#59B3A9',
  yellow: '#FFC65C',
  orange: '#FF8000',
  red: '#F60606',
  grey: '#6C6969',
  lightBlue:'#A7E6FF'
}

export const sortOrderMap = {
  asc: 1,
  desc: -1
}

export const userStatusMap = {
  'inProcess': 1,
  'completedSignup': 2,
  'active': 3,
  'accessDenied': 4
}

export const userStatusColors = {
  1: indicatorColors.yellow,  // In Process
  2: indicatorColors.green,   // Completed Signup
  3: indicatorColors.green,   // Active
  4: indicatorColors.red,     // Access Disabled
};

export const clientStatusColors = {
  1: indicatorColors.yellow,  // In Process
  2: indicatorColors.green,   // Active
  3: indicatorColors.green,   // Active Certified
  4: indicatorColors.red,     // Access Disabled
};

export const groupStatusColors = {
  1: indicatorColors.yellow,  // Not Started
  2: indicatorColors.green,   // Active
  3: indicatorColors.blue,   // Completed
  4: indicatorColors.red,     // Discontinued
};

export const participantGroupStatusColors = {
  1: indicatorColors.green,   // Active
  2: indicatorColors.green,   // Not Started
  3: indicatorColors.red,     // Inactive
};

export const measurementStatusColors = {
  1: indicatorColors.green,   // Active
  2: indicatorColors.red,     // Inactive
}

export const groupStatuses = {
  1: 'Not Started',
  2: 'Active',
  3: 'Completed',
  4: 'Discontinued'
}